module.exports = __webpack_public_path__ + "static/media/service-account.59dd04ec.png";